export default theme => ({

     buttonNav2: {
      '&.MuiTypography-colorPrimary': {
        color: "#7D7D7D"
      },
      '&.MuiTypography-root': {
        margin: '4px',
      },
    }, 
  });